import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { Tabs } from '@ui/components/Tabs';

import { TournamentSystem } from '@features/shared/api/typings';
import { TournamentEditFormValues } from '@features/tournament/ui/components/TournamentSettings/typings';

const gameSystemTabs: {
  value: TournamentSystem;
  label: string;
  disabled?: boolean;
}[] = [
  { value: 'RoundRobin', label: 'Круговая' },
  { value: 'Swiss', label: 'Швейцарская' },
  {
    value: 'Knockout',
    label: 'Нокаут (олимпийская)',
  },
];

export function GameSystemInput() {
  const { control } = useFormContext<TournamentEditFormValues>();

  return (
    <FormRow>
      <FormLabel>Система проведения</FormLabel>
      <FormInput>
        <Controller
          name="system"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <Tabs tabs={gameSystemTabs} value={value} onChange={onChange} disabled={disabled} />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
